import React, { useState, useEffect, useContext } from 'react'

// Translation
import { useTranslation } from 'react-multi-lang'

// Redux
import { useDispatch, useSelector } from 'react-redux'
import { glassWork, addPriceSlice, addPriceState, select, glass } from './AddPriceSlice'

// Gird system
import { Col, Row } from 'react-grid-system'

// Components
import Modal from '../../../components/Modal/Modal'
import { InputField, SelectField } from '../../../components/FormElements/FormElements'

// Stylesheet
// import './ManageAttributes.css'
import { price, priceResponse } from '../../../services/api/api'
import { SuccessMark, WhiteboxLoader } from '../../../components/Loader/Loader'
import { productsSlice } from '../PricingSlice'
import { useNotification } from '../../../services/usenotification'
import { Divider } from '@mui/material'
import SettingContext from '../../../services/context/setting-contentxt/setting-context'

import { useAPI } from '../../../services/hoc/useAPI'
import { AxiosError } from 'axios'

export default ({close}:{close:Function}) => {

    // Translation
    const t = useTranslation()
    const {alertError500}=useNotification()

    // Redux
    const dispatch = useDispatch()
    const state = useSelector((state: { add_price: addPriceState }) => state.add_price)

  const ENDPOINTS = useAPI()

  
   const {isMobile} =useContext(SettingContext)
    const [serviceOptions, setServiceOptions] = useState<select[]>([])
    const [materialOptions, setMaterialsOptions] = useState<select[]>([])

    const toggle = () => {
        dispatch(addPriceSlice.actions.setIsOpen(!state.isOpen))
        dispatch(addPriceSlice.actions.init())
        close()
    }

    // Fetch Data
    const fetchData = (page: number, page_size: number = 10) => {
        dispatch(addPriceSlice.actions.setIsLoading(true))

        // Get Services
        ENDPOINTS.glasses().serviceNotPriced({})
            .then((response: any) => {
                let services: glassWork[] = response.data.data[0].notpriced.map((service: any): glassWork => ({
                    id: service.id,
                    name: service.name,
                    code: service.code
                }))

                let options: select[] = response.data.data[0].notpriced.map((service: any): select => ({
                    label: service.name,
                    value: service.id
                }))
          
                setServiceOptions(pre =>options);


                dispatch(addPriceSlice.actions.setIsLoading(false))
                dispatch(addPriceSlice.actions.addServices(services))
            })
            .catch((err:any)=>{
                alertError500(err)
                dispatch(addPriceSlice.actions.setIsLoading(false))
            })


        // Get Materials
        ENDPOINTS.glassWorks().glassNotPriced({})
            .then((response: any) => {
                let materials: glass[] = response.data.data[0].notpriced.map((material: any): glass => ({
                    id: material.id,
                    name: material.name,
                    code: material.code
                }))

                let options: select[] = response.data.data[0].notpriced.map((material: any): select => ({
                    label: material.name,
                    value: material.id
                }))

                setMaterialsOptions(pre=>options);


                dispatch(addPriceSlice.actions.setIsLoading(false))
                dispatch(addPriceSlice.actions.addMaterials(materials))
            })
            .catch((err:any)=>{
                alertError500(err)
                dispatch(addPriceSlice.actions.setIsLoading(false))
            })

    }
    const submit = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault()

        dispatch(addPriceSlice.actions.setIsLoading(true))
        ENDPOINTS.pricing().addPrices({ prices: state.prices })
        .then((response: any) => {
            let added_prices = response.data.data.filter((ele:priceResponse)=>
             state.prices.filter(elem=>parseInt(elem.glass_id??'-1') === ele.gid
              && parseInt(elem.glass_work_id??'-1') === ele.gwid)[0]  )
            
            if (added_prices.length>0){
                let prices_response:price[]=added_prices.map((ele:priceResponse)=> ({
                    "id": ele.pid,
                    "glass_id":ele.gid,
                    "glass_work_id":ele.gwid,
                    "price": ele.price,
                
                    "glassworks": {
                        id: ele.gwid,
                        name: ele.gwname,
                        code: ele.gwcode
                    },
                    "glasses": {
                        id:ele.gid,
                        name:ele.gname,
                        code:ele.gcode
                    }
                }))
                dispatch(productsSlice.actions.addPrices(prices_response))
                dispatch(addPriceSlice.actions.setIsLoading(false))
                dispatch(addPriceSlice.actions.setIsSuccess(true))
                setTimeout(() => {
                    toggle()
                    // dispatch(materialsSlice.actions.setMaterial({showMaterial: true, material:}))
                    dispatch(addPriceSlice.actions.setIsOpen(false))
                }, 1000);
            }
        })
        .catch((err:AxiosError)=>{
            alertError500(err)
                dispatch(addPriceSlice.actions.setIsLoading(false))
                dispatch(addPriceSlice.actions.setIsSuccess(false))
                     setTimeout(() => {
                    toggle()
                    // dispatch(materialsSlice.actions.setMaterial({showMaterial: true, material:}))
                    dispatch(addPriceSlice.actions.setIsOpen(false))
                }, 1000);
        })
        
            
    }


    // First fetch
    useEffect(() => {
        // if (!state.isLoaded && !state.isFetching)
       
        fetchData(1)
    }, [])

    return (
        <Modal open={state.isOpen} toggle={toggle}>

            {state.isLoading ? <WhiteboxLoader /> : ""}

            {state.isSuccess ? <SuccessMark /> : ""}

            <h2 className="text-center" style={{ margin: "0 0 20px" }}>{t("pricing")}</h2>

            <form onSubmit={submit} style={{ width:isMobile?"280px" :"450px" }}>

                {
                    state.prices.map((price, index) => (
                        <div className="attribute" key={index}>
                            <div className="attribute-fields" style={state.prices.length > 1 ? {} : { padding: 0 }}>
                                <Row style={{marginBlock:'5px'}}> 
                                    <Col md={12}>
                                        <SelectField
                                            options={serviceOptions}
                                            placeholder={`${t('service')}...`}
                                            value={serviceOptions.find(option => option.value === price.glass_work_id)}
                                            onChange={(option: { value: string }) => dispatch(addPriceSlice.actions.setService({ index, value: option.value }))}
                                        />
                                    </Col>

                                    <Col md={12}>
                                        <SelectField
                                            options={materialOptions}
                                            placeholder={`${t('material')}...`}
                                            value={materialOptions.find(option => option.value === price.glass_id)}
                                            onChange={(option: { value: string }) => dispatch(addPriceSlice.actions.setMaterial({ index, value: option.value }))}
                                        />
                                    </Col>

                                    <Col md={12}>
                                        <InputField
                                            type="number"
                                            label={t("price")}
                                            value={state.prices[index].price}
                                            onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                                dispatch(addPriceSlice.actions.setPriceValue({ index, value: e.target.value }));
                                            }}
                                        // error={ showErrors && !attribute.hint ? t("required_error") : "" }
                                        />
                                    </Col>
                                    <Col xs={12}>
                                        <Divider variant='middle' sx={{background:'lightgray'}}  />
                                    </Col>


                                </Row>
                            </div>
                            {state.prices.length > 1 ? <i className="icon-delete" onClick={
                                () => {
                                
                                    dispatch(addPriceSlice.actions.deletePrice(index))
                                }
                            }></i> : ""}
                        </div>
                    ))
                }

                <div className="text-left">
                    <button className="button bg-white color-gold margin-top-30"
                        onClick={(e: React.MouseEvent<HTMLButtonElement>) => {
                            e.preventDefault()
                            dispatch(addPriceSlice.actions.set([{ price: "0" }]))
                        }}><i className='icon-plus'></i></button>
                </div>

                <button className="button round bg-gold color-white margin-top-20" 
                style={{ padding:isMobile? "0 40px":"0 80px", marginBottom: 5 }} >{t("submit")}</button>

            </form>

        </Modal>
    );
}